import React from 'react'


// Shimmer UI for Home Page Videos
const ShimmerUI = () => {
  return (
    <div className='flex flex-wrap'>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600' >
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        <div className='m-2 w-60 h-[300px] shadow-lg bg-gray-100 dark:bg-slate-600'>
            <div className='w-50 h-[150px] bg-gray-200 dark:bg-slate-700 rounded-lg'></div>
        </div>
        
    </div>
  )
}

export default ShimmerUI